import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Dialog from '../../../components/Dialog';
import ForgotPasswordForm from './ForgotPasswordForm';

// ----------------------------------------------------------------------

export default function ForgotPasswordDialog(props) {

  return (
    <Dialog
      {...props}
      title={<FormattedMessage id='forgotPassword.dialog.title' defaultMessage='Reset password' />}
    >
      <ForgotPasswordForm onClose={props.onClose} />
    </Dialog>
  );
}

ForgotPasswordDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
